import { useEffect } from "react";

/**
 * Bind keyboard shortcuts. `map` is { "ctrl+z": handler, "ctrl+shift+z": handler, ... }.
 * Case-insensitive keys. Supports ctrl/meta, shift, alt, key.
 */
export function useKeyboardShortcuts(map, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const norm = (parts) => parts.sort().join("+").toLowerCase();
    const normalized = Object.fromEntries(
      Object.entries(map).map(([k, v]) => [norm(k.toLowerCase().split("+").map((s) => s.trim())), v])
    );

    const handler = (e) => {
      const parts = [];
      if (e.ctrlKey || e.metaKey) parts.push("ctrl");
      if (e.shiftKey) parts.push("shift");
      if (e.altKey) parts.push("alt");
      parts.push((e.key || "").toLowerCase());
      const key = norm(parts);
      const fn = normalized[key];
      if (fn) {
        e.preventDefault();
        fn(e);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [map, enabled]);
}
